import { useMemo } from "react";
import clsx from "clsx";

import { IStepItem } from "models/Component";
import styles from "./style.module.scss";

interface IProps {
  data: Array<IStepItem>;
  currentStep: number;
  setStep: (step: number) => void;
  canNavigate?: boolean;
  className?: string;
  containClass?: string;
  isHideMobileTitle?: boolean;
}

export default function Stepper({
  data,
  containClass,
  className,
  currentStep,
  isHideMobileTitle = false,
  setStep,
  canNavigate = true
}: Readonly<IProps>) {
  const { title, description } = useMemo(() => {
    const step = data.find((item) => item.id === currentStep + 1);
    return { title: step?.name, description: step?.description };
  }, [currentStep]);

  const activeColor = (index: number) => (currentStep >= index ? "bg-primary" : "bg-subtitle");
  const isFinalStep = (index: number) => index === data.length;

  const stepStyles = [styles.forward, styles.completed, styles.active, styles.active];

  return (
    <div
      className={clsx(
        styles.smartStepperContainer,
        containClass,
        !title && "desktop:!bg-transparent desktop:!p-0",
        description && "desktop:items-end desktop:pt-7"
      )}>
      <div className="flex flex-col gap-1.5">
        <span className={styles.title}>{title}</span>
        {description && <span className={styles.description}>{description}</span>}
      </div>

      <ul className={clsx(styles.smartStepperList, className, description && "desktop:mb-3")}>
        {data.map((item, index) => (
          <li
            key={item.id}
            className={clsx(currentStep === data.length - 1 && "*:desktop:bg-success")}>
            <div className="desktop:hidden">
              <button
                onClick={canNavigate || index < currentStep ? () => setStep(index) : () => {}}
                className={styles.stepperItem}>
                <span
                  className={clsx(styles.stepIndex, {
                    [styles.forward]: currentStep < index,
                    [styles.completed]: currentStep > index,
                    [styles.active]: currentStep === index
                  })}>
                  {index + 1}
                </span>

                <span
                  className={clsx(
                    styles.stepLabel,
                    {
                      [styles.forward]: currentStep < index,
                      [styles.completed]: currentStep > index,
                      [styles.active]: currentStep === index
                    },
                    isHideMobileTitle && "mobile:hidden"
                  )}>
                  {item.name}
                </span>
              </button>
            </div>
            {isFinalStep(index) ? null : (
              <div className={`w-20 h-1.5 rounded-md mobile:hidden ${activeColor(index)}`}></div>
            )}
          </li>
        ))}
        <div className={clsx(styles.stepLine, stepStyles[currentStep])}></div>
      </ul>
    </div>
  );
}
